/**
 * Gift matching pools constants
 */

import config from '../../../constants';

const base = 'systemSettings.giftMatchingPools';

export const i18nKeys = {
  TITLE: `${base}.title`,
  DESCRIPTION: `${base}.description`,
  BACK: `${base}.back`,
  LIST: {
    CREATE: `${base}.list.create`,
    EMPTY: `${base}.list.empty`,
    NAME: `${base}.list.name`,
    STATUS: `${base}.list.status`,
    ON: `${base}.list.on`,
    OFF: `${base}.list.off`,
    MULTIPLIER: `${base}.list.multiplier`,
    MULTIPLIER_VALUE: `${base}.list.multiplierValue`,
    CAMPAIGNS: `${base}.list.campaigns`,
    MATCHED: `${base}.list.matched`,
    MATCHED_VALUE: `${base}.list.matchedValue`,
    UPDATED: `${base}.list.updated`,
    UPDATED_VALUE: `${base}.list.updatedValue`,
    ACTIONS: `${base}.list.actions`,
    EDIT: `${base}.list.edit`
  },
  CREATE: {
    TITLE: `${base}.create.title`,
    SOURCE_TITLE: `${base}.create.sourceTitle`,
    SOURCE_HELP: `${base}.create.sourceHelp`,
    SOURCE_CAMPAIGN: `${base}.create.sourceCampaign`,
    SOURCE_GIFT_MATCH: `${base}.create.sourceGiftMatch`,
    SOURCE_POOLED: `${base}.create.sourcePooled`,
    SOURCE_PAGE_CONDITIONS: `${base}.create.sourcePageConditions`,
    SOURCE_NAME_TOO_LONG: `${base}.create.sourceNameTooLong`,
    SOURCE_CHANGE: `${base}.create.sourceChange`,
    NO_GIFT_MATCHES: `${base}.create.noGiftMatches`,
    CHOOSE_SOURCE_FIRST: `${base}.create.chooseSourceFirst`,
    TARGETS_TITLE: `${base}.create.targetsTitle`,
    TARGETS_HELP: `${base}.create.targetsHelp`,
    SUBMIT: `${base}.create.submit`
  },
  SUMMARY: {
    TITLE: `${base}.summary.title`,
    HELP: `${base}.summary.help`,
    EDIT_ON_CAMPAIGN: `${base}.summary.editOnCampaign`,
    NEW_TAB: `${base}.summary.newTab`,
    REFRESH: `${base}.summary.refresh`,
    NOT_SET: `${base}.summary.notSet`,
    NO_CONDITIONS: `${base}.summary.noConditions`,
    CONDITION_VALUE: `${base}.summary.conditionValue`,
    AMOUNT_RANGE: `${base}.summary.amountRange`
  },
  EDIT: {
    TITLE: `${base}.edit.title`,
    CAMPAIGNS_TITLE: `${base}.edit.campaignsTitle`,
    ADD_TITLE: `${base}.edit.addTitle`,
    ADD_BUTTON: `${base}.edit.addButton`,
    SETTINGS_TITLE: `${base}.edit.settingsTitle`,
    SAVE: `${base}.edit.save`,
    SAVED: `${base}.edit.saved`,
    CREATED: `${base}.edit.created`,
    ADDED: `${base}.edit.added`,
    REMOVED: `${base}.edit.removed`,
    AUDIT: `${base}.edit.audit`,
    UNKNOWN_ACCOUNT: `${base}.edit.unknownAccount`,
    LAST_CAMPAIGN: `${base}.edit.lastCampaign`
  },
  CAMPAIGNS: {
    CAMPAIGN: `${base}.campaigns.campaign`,
    ORGANISATION: `${base}.campaigns.organisation`,
    CURRENCY: `${base}.campaigns.currency`,
    MATCHED: `${base}.campaigns.matched`,
    ACTIONS: `${base}.campaigns.actions`,
    REMOVE: `${base}.campaigns.remove`,
    REMOVE_FROM_LIST: `${base}.campaigns.removeFromList`
  },
  PICKER: {
    SEARCH: `${base}.picker.search`,
    PLACEHOLDER: `${base}.picker.placeholder`,
    SEARCH_FAILED: `${base}.picker.searchFailed`,
    STATUS: `${base}.picker.status`,
    ID: `${base}.picker.id`,
    ADD_BY_ID: `${base}.picker.addById`,
    INCLUDE_OTHER_ORGANISATIONS: `${base}.picker.includeOtherOrganisations`,
    ORGANISATION_ONLY: `${base}.picker.organisationOnly`
  },
  WARNINGS: {
    MULTI_ORGANISATION_TITLE: `${base}.warnings.multiOrganisationTitle`,
    MULTI_ORGANISATION: `${base}.warnings.multiOrganisation`,
    CURRENCY: `${base}.warnings.currency`,
    DUPLICATE: `${base}.warnings.duplicate`
  },
  REMOVE: {
    TITLE: `${base}.remove.title`,
    BODY: `${base}.remove.body`,
    KEEP: `${base}.remove.keep`,
    DELETE: `${base}.remove.delete`,
    CONFIRM: `${base}.remove.confirm`,
    CANCEL: `${base}.remove.cancel`
  },
  FIELDS: {
    ENABLED: `${base}.fields.enabled`,
    ENABLED_HELP: `${base}.fields.enabledHelp`,
    CONDITIONS_TITLE: `${base}.fields.conditionsTitle`,
    CONDITIONS_HELP: `${base}.fields.conditionsHelp`,
    PAGE_CONDITIONS_NOTE: `${base}.fields.pageConditionsNote`,
    VALUE: `${base}.fields.value`,
    FROM: `${base}.fields.from`,
    TO: `${base}.fields.to`,
    DATE_TIME: `${base}.fields.dateTime`
  },
  ERRORS: {
    LOAD_FAILED: `${base}.errors.loadFailed`,
    SUMMARY_FAILED: `${base}.errors.summaryFailed`,
    SAVE_FAILED: `${base}.errors.saveFailed`,
    CREATE_FAILED: `${base}.errors.createFailed`,
    ADD_FAILED: `${base}.errors.addFailed`,
    REMOVE_FAILED: `${base}.errors.removeFailed`,
    CONDITIONS_REQUIRED: `${base}.errors.conditionsRequired`,
    CONDITION_VALUE_REQUIRED: `${base}.errors.conditionValueRequired`,
    CONDITION_VALUE_INVALID: `${base}.errors.conditionValueInvalid`,
    CONDITION_RANGE: `${base}.errors.conditionRange`,
    PAGE_CONDITIONS: `${base}.errors.pageConditions`,
    CURRENCY: `${base}.errors.currency`,
    CAMPAIGN_ALREADY_LINKED: `${base}.errors.campaignAlreadyLinked`,
    CAMPAIGN_NOT_FOUND: `${base}.errors.campaignNotFound`,
    TARGETS_REQUIRED: `${base}.errors.targetsRequired`,
    SOURCE_REQUIRED: `${base}.errors.sourceRequired`,
    SOURCE_POOLED: `${base}.errors.sourcePooled`,
    SOURCE_NOT_FOUND: `${base}.errors.sourceNotFound`,
    LAST_CAMPAIGN: `${base}.errors.lastCampaign`,
    NAME_REQUIRED: `${base}.errors.nameRequired`,
    NAME_INVALID: `${base}.errors.nameInvalid`,
    MULTIPLIER_INVALID: `${base}.errors.multiplierInvalid`,
    DONATION_INVALID: `${base}.errors.donationInvalid`
  }
};

// Labels shared with the campaign gift matching section, so both screens use the same words.
const giftMatchingModel = 'template.page.content.giftMatching.model';

export const giftMatchingKeys = {
  NAME: `${giftMatchingModel}.name.label`,
  NAME_SUBTEXT: `${giftMatchingModel}.name.subtext`,
  MULTIPLIER: `${giftMatchingModel}.multiplier.label`,
  MULTIPLIER_SUBTEXT: `${giftMatchingModel}.multiplier.subtext`,
  DONATION_FROM: `${giftMatchingModel}.donationFrom.label`,
  DONATION_FROM_SUBTEXT: `${giftMatchingModel}.donationFrom.subtext`,
  DONATION_MESSAGE: `${giftMatchingModel}.donationMessage.label`,
  DONATION_MESSAGE_SUBTEXT: `${giftMatchingModel}.donationMessage.subtext`,
  IMAGE: `${giftMatchingModel}.image.label`,
  IMAGE_SUBTEXT: `${giftMatchingModel}.image.subtext`,
  CONDITIONS: {
    START: `${giftMatchingModel}.conditions.startDateTime.label`,
    END: `${giftMatchingModel}.conditions.endDateTime.label`,
    GIFT_MATCHING_TOTAL: `${giftMatchingModel}.conditions.giftMatchingTotal.label`,
    CAMPAIGN_TOTAL: `${giftMatchingModel}.conditions.campaignTotal.label`,
    DONATION_COUNT: `${giftMatchingModel}.conditions.donationCount.label`,
    DONATION_AMOUNT: `${giftMatchingModel}.conditions.donationAmount.label`,
    DONATION_AMOUNT_OPERATOR: `${giftMatchingModel}.conditions.donationAmount.operators`
  }
};

/** The API's error codes, as `{param}.{code}`, mapped to the message shown for each. */
export const apiErrorMessageKeys: Record<string, string> = {
  'campaignIds.invalid': i18nKeys.ERRORS.CAMPAIGN_ALREADY_LINKED,
  'campaignIds.notFound': i18nKeys.ERRORS.CAMPAIGN_NOT_FOUND,
  'campaignIds.required': i18nKeys.ERRORS.TARGETS_REQUIRED,
  'conditions.invalid': i18nKeys.ERRORS.PAGE_CONDITIONS,
  'conditions.required': i18nKeys.ERRORS.CONDITIONS_REQUIRED,
  'currency.invalid': i18nKeys.ERRORS.CURRENCY,
  'donation.invalid': i18nKeys.ERRORS.DONATION_INVALID,
  'giftMatchingId.invalid': i18nKeys.ERRORS.LAST_CAMPAIGN,
  'multiplier.invalid': i18nKeys.ERRORS.MULTIPLIER_INVALID,
  'name.invalid': i18nKeys.ERRORS.NAME_INVALID,
  'name.required': i18nKeys.ERRORS.NAME_REQUIRED,
  'sourceGiftMatchingId.invalid': i18nKeys.ERRORS.SOURCE_POOLED,
  'sourceGiftMatchingId.notFound': i18nKeys.ERRORS.SOURCE_NOT_FOUND
};

export const campaignSearchDelayMs = 500;
export const maxMultiplier = 5;
/** The campaign editor's gift match name limit, which pooled gift matches must also pass. */
export const nameMaxLength = config.GIFTMATCHINGBUILDER_NAME_MAX_LENGTH;
export const donationFromMaxLength = 40;
export const donationMessageMaxLength = 280;
